import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const StyledTextField = styled(TextField)(({ theme }) => ({
    marginTop: '12px',
    '& .MuiInputLabel-root': {
        fontSize: '14px',
        transform: 'translate(14px, 16px) scale(1)',
        '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.85)',
            backgroundColor: '#ffffff',
        },
    },
    '& .MuiInputBase-input': {
        fontSize: '14px',
        padding: '15.5px 14px',
    },
    '& .MuiInputBase-multiline': {
        padding: 0,
    },
    '& .MuiInputAdornment-positionStart': {
        paddingLeft: 0,
    },
    '& .MuiSelect-select': {
        padding: 14.6,
    },
}));

// Using default parameter instead of defaultProps
const CustomTextField = ({ children = null, ...otherProps }) => {
    return (
        <StyledTextField {...otherProps}>
            {children}
        </StyledTextField>
    );
};

CustomTextField.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

export default CustomTextField;
